/**
 * Kennzeichen-Validierung (deutsche Kfz-Kennzeichen).
 *
 * Erkennt offline:
 *  • Stadt/Landkreis aus dem Unterscheidungszeichen (1-3 Buchstaben)
 *  • Bundesland
 *  • Plausibilität nach FZV §8
 *
 * Datenquelle: Bundesamt für Justiz, FZV (Fahrzeug-Zulassungsverordnung).
 * Komplett offline, kein API-Call.
 */

/* eslint-disable sort-keys */
// Häufigste Unterscheidungszeichen (Top-150 nach Einwohnern).
// Quelle: Bundesamt für Justiz, FZV Anlage 1.
const PLATE_REGISTRY = {
  // === Bayern ===
  M: { city: "München", state: "Bayern" },
  N: { city: "Nürnberg", state: "Bayern" },
  A: { city: "Augsburg", state: "Bayern" },
  R: { city: "Regensburg", state: "Bayern" },
  WÜ: { city: "Würzburg", state: "Bayern" },
  IN: { city: "Ingolstadt", state: "Bayern" },
  ER: { city: "Erlangen", state: "Bayern" },
  FÜ: { city: "Fürth", state: "Bayern" },
  BT: { city: "Bayreuth", state: "Bayern" },
  BA: { city: "Bamberg", state: "Bayern" },
  KU: { city: "Kulmbach", state: "Bayern" },
  HO: { city: "Hof", state: "Bayern" },
  WM: { city: "Weilheim-Schongau", state: "Bayern" },
  RO: { city: "Rosenheim", state: "Bayern" },
  TS: { city: "Traunstein", state: "Bayern" },
  PA: { city: "Passau", state: "Bayern" },
  DEG: { city: "Deggendorf", state: "Bayern" },
  LA: { city: "Landshut", state: "Bayern" },
  EI: { city: "Eichstätt", state: "Bayern" },
  AS: { city: "Amberg-Sulzbach", state: "Bayern" },
  NEW: { city: "Neustadt an der Waldnaab", state: "Bayern" },
  CO: { city: "Coburg", state: "Bayern" },
  KC: { city: "Kronach", state: "Bayern" },

  // === Baden-Württemberg ===
  S: { city: "Stuttgart", state: "Baden-Württemberg" },
  KA: { city: "Karlsruhe", state: "Baden-Württemberg" },
  MA: { city: "Mannheim", state: "Baden-Württemberg" },
  HD: { city: "Heidelberg", state: "Baden-Württemberg" },
  FR: { city: "Freiburg im Breisgau", state: "Baden-Württemberg" },
  HN: { city: "Heilbronn", state: "Baden-Württemberg" },
  PF: { city: "Pforzheim", state: "Baden-Württemberg" },
  UL: { city: "Ulm", state: "Baden-Württemberg" },
  TÜ: { city: "Tübingen", state: "Baden-Württemberg" },
  RT: { city: "Reutlingen", state: "Baden-Württemberg" },
  AA: { city: "Aalen / Ostalbkreis", state: "Baden-Württemberg" },
  KN: { city: "Konstanz", state: "Baden-Württemberg" },
  RV: { city: "Ravensburg", state: "Baden-Württemberg" },
  FN: { city: "Friedrichshafen", state: "Baden-Württemberg" },
  ES: { city: "Esslingen am Neckar", state: "Baden-Württemberg" },
  LB: { city: "Ludwigsburg", state: "Baden-Württemberg" },
  BB: { city: "Böblingen", state: "Baden-Württemberg" },
  WN: { city: "Waiblingen / Rems-Murr-Kreis", state: "Baden-Württemberg" },
  GP: { city: "Göppingen", state: "Baden-Württemberg" },
  HDH: { city: "Heidenheim", state: "Baden-Württemberg" },
  OG: { city: "Offenburg", state: "Baden-Württemberg" },
  LÖ: { city: "Lörrach", state: "Baden-Württemberg" },

  // === Nordrhein-Westfalen ===
  K: { city: "Köln", state: "Nordrhein-Westfalen" },
  D: { city: "Düsseldorf", state: "Nordrhein-Westfalen" },
  DO: { city: "Dortmund", state: "Nordrhein-Westfalen" },
  E: { city: "Essen", state: "Nordrhein-Westfalen" },
  DU: { city: "Duisburg", state: "Nordrhein-Westfalen" },
  BO: { city: "Bochum", state: "Nordrhein-Westfalen" },
  BN: { city: "Bonn", state: "Nordrhein-Westfalen" },
  MS: { city: "Münster", state: "Nordrhein-Westfalen" },
  AC: { city: "Aachen", state: "Nordrhein-Westfalen" },
  GE: { city: "Gelsenkirchen", state: "Nordrhein-Westfalen" },
  OB: { city: "Oberhausen", state: "Nordrhein-Westfalen" },
  HA: { city: "Hagen", state: "Nordrhein-Westfalen" },
  KR: { city: "Krefeld", state: "Nordrhein-Westfalen" },
  MG: { city: "Mönchengladbach", state: "Nordrhein-Westfalen" },
  HER: { city: "Herne", state: "Nordrhein-Westfalen" },
  MH: { city: "Mülheim an der Ruhr", state: "Nordrhein-Westfalen" },
  RE: { city: "Recklinghausen", state: "Nordrhein-Westfalen" },
  SI: { city: "Siegen-Wittgenstein", state: "Nordrhein-Westfalen" },
  PB: { city: "Paderborn", state: "Nordrhein-Westfalen" },
  BI: { city: "Bielefeld", state: "Nordrhein-Westfalen" },
  GT: { city: "Gütersloh", state: "Nordrhein-Westfalen" },
  MI: { city: "Minden-Lübbecke", state: "Nordrhein-Westfalen" },
  LIP: { city: "Lippe", state: "Nordrhein-Westfalen" },
  SO: { city: "Soest", state: "Nordrhein-Westfalen" },
  HSK: { city: "Hochsauerlandkreis", state: "Nordrhein-Westfalen" },
  HX: { city: "Höxter", state: "Nordrhein-Westfalen" },
  COE: { city: "Coesfeld", state: "Nordrhein-Westfalen" },
  BOR: { city: "Borken", state: "Nordrhein-Westfalen" },
  WAF: { city: "Warendorf", state: "Nordrhein-Westfalen" },
  EN: { city: "Ennepe-Ruhr-Kreis", state: "Nordrhein-Westfalen" },
  UN: { city: "Unna", state: "Nordrhein-Westfalen" },
  SU: { city: "Rhein-Sieg-Kreis", state: "Nordrhein-Westfalen" },
  ME: { city: "Mettmann", state: "Nordrhein-Westfalen" },

  // === Hessen ===
  F: { city: "Frankfurt am Main", state: "Hessen" },
  WI: { city: "Wiesbaden", state: "Hessen" },
  KS: { city: "Kassel", state: "Hessen" },
  DA: { city: "Darmstadt", state: "Hessen" },
  GI: { city: "Gießen", state: "Hessen" },
  OF: { city: "Offenbach am Main", state: "Hessen" },
  FB: { city: "Friedberg / Wetterau", state: "Hessen" },
  HG: { city: "Bad Homburg / Hochtaunuskreis", state: "Hessen" },
  MTK: { city: "Main-Taunus-Kreis", state: "Hessen" },
  MR: { city: "Marburg-Biedenkopf", state: "Hessen" },
  LDK: { city: "Lahn-Dill-Kreis", state: "Hessen" },
  FD: { city: "Fulda", state: "Hessen" },

  // === Berlin / Brandenburg ===
  B: { city: "Berlin", state: "Berlin" },
  P: { city: "Potsdam", state: "Brandenburg" },
  CB: { city: "Cottbus", state: "Brandenburg" },
  FF: { city: "Frankfurt (Oder)", state: "Brandenburg" },
  BRB: { city: "Brandenburg an der Havel", state: "Brandenburg" },
  HVL: { city: "Havelland", state: "Brandenburg" },
  OHV: { city: "Oberhavel", state: "Brandenburg" },
  TF: { city: "Teltow-Fläming", state: "Brandenburg" },
  LDS: { city: "Dahme-Spreewald", state: "Brandenburg" },
  PM: { city: "Potsdam-Mittelmark", state: "Brandenburg" },

  // === Hamburg / Bremen / Niedersachsen ===
  HH: { city: "Hamburg", state: "Hamburg" },
  HB: { city: "Bremen", state: "Bremen" },
  H: { city: "Hannover", state: "Niedersachsen" },
  BS: { city: "Braunschweig", state: "Niedersachsen" },
  OL: { city: "Oldenburg", state: "Niedersachsen" },
  OS: { city: "Osnabrück", state: "Niedersachsen" },
  WOB: { city: "Wolfsburg", state: "Niedersachsen" },
  EMS: { city: "Emsland", state: "Niedersachsen" },
  AUR: { city: "Aurich", state: "Niedersachsen" },
  CE: { city: "Celle", state: "Niedersachsen" },
  GÖ: { city: "Göttingen", state: "Niedersachsen" },
  HI: { city: "Hildesheim", state: "Niedersachsen" },
  WL: { city: "Harburg", state: "Niedersachsen" },
  STD: { city: "Stade", state: "Niedersachsen" },
  ROW: { city: "Rotenburg (Wümme)", state: "Niedersachsen" },
  DH: { city: "Diepholz", state: "Niedersachsen" },
  NI: { city: "Nienburg/Weser", state: "Niedersachsen" },

  // === Schleswig-Holstein / Mecklenburg-Vorpommern ===
  KI: { city: "Kiel", state: "Schleswig-Holstein" },
  L: { city: "Lübeck", state: "Schleswig-Holstein" },
  FL: { city: "Flensburg", state: "Schleswig-Holstein" },
  NF: { city: "Nordfriesland", state: "Schleswig-Holstein" },
  HL: { city: "Lübeck (Hansestadt)", state: "Schleswig-Holstein" },
  HEI: { city: "Dithmarschen", state: "Schleswig-Holstein" },
  HRO: { city: "Rostock", state: "Mecklenburg-Vorpommern" },
  HWI: { city: "Wismar", state: "Mecklenburg-Vorpommern" },
  HST: { city: "Stralsund", state: "Mecklenburg-Vorpommern" },
  HGW: { city: "Greifswald", state: "Mecklenburg-Vorpommern" },
  SN: { city: "Schwerin", state: "Mecklenburg-Vorpommern" },
  NB: { city: "Neubrandenburg", state: "Mecklenburg-Vorpommern" },

  // === Sachsen / Sachsen-Anhalt / Thüringen ===
  DD: { city: "Dresden", state: "Sachsen" },
  LE: { city: "Leipzig (Landkreis)", state: "Sachsen" },
  C: { city: "Chemnitz", state: "Sachsen" },
  Z: { city: "Zwickau", state: "Sachsen" },
  PL: { city: "Plauen", state: "Sachsen" },
  GR: { city: "Görlitz", state: "Sachsen" },
  MD: { city: "Magdeburg", state: "Sachsen-Anhalt" },
  HAL: { city: "Halle (Saale)", state: "Sachsen-Anhalt" },
  DE: { city: "Dessau-Roßlau", state: "Sachsen-Anhalt" },
  J: { city: "Jena", state: "Thüringen" },
  EF: { city: "Erfurt", state: "Thüringen" },
  G: { city: "Gera", state: "Thüringen" },
  WE: { city: "Weimar", state: "Thüringen" },
  SHL: { city: "Suhl", state: "Thüringen" },
  EA: { city: "Eisenach", state: "Thüringen" },

  // === Rheinland-Pfalz / Saarland ===
  MZ: { city: "Mainz", state: "Rheinland-Pfalz" },
  KO: { city: "Koblenz", state: "Rheinland-Pfalz" },
  TR: { city: "Trier", state: "Rheinland-Pfalz" },
  KL: { city: "Kaiserslautern", state: "Rheinland-Pfalz" },
  LU: { city: "Ludwigshafen am Rhein", state: "Rheinland-Pfalz" },
  PS: { city: "Pirmasens", state: "Rheinland-Pfalz" },
  WO: { city: "Worms", state: "Rheinland-Pfalz" },
  SP: { city: "Speyer", state: "Rheinland-Pfalz" },
  NW: { city: "Neustadt an der Weinstraße", state: "Rheinland-Pfalz" },
  SB: { city: "Saarbrücken", state: "Saarland" },
  HOM: { city: "Homburg / Saar-Pfalz-Kreis", state: "Saarland" },
};

/* eslint-enable sort-keys */

/**
 * Erkennt das Unterscheidungszeichen (1-3 Buchstaben am Anfang).
 */
function extractDistrictCode(plate) {
  const cleaned = plate
    .toUpperCase()
    .replace(/[^A-ZÄÖÜ0-9 -]/g, "")
    .trim();

  // Format: "M-AB 1234" oder "M AB 1234" → erstes Wort ist District-Code
  const parts = cleaned.split(/[\s-]+/);
  if (!parts.length) return null;

  const code = parts[0];
  // 1-3 Buchstaben erlaubt
  if (!/^[A-ZÄÖÜ]{1,3}$/.test(code)) return null;
  return code;
}

/**
 * Erkennt das Erkennungszeichen (1-2 Buchstaben nach dem District-Code)
 * und die Erkennungsnummer (1-4 Ziffern).
 */
function parsePlateBody(plate) {
  // FZV §8: Erkennungszeichen = 1-2 Buchstaben + 1-4 Ziffern
  const match = plate
    .toUpperCase()
    .replace(/[^A-ZÄÖÜ0-9 -]/g, "")
    .match(/^([A-ZÄÖÜ]{1,3})[\s-]+([A-ZÄÖÜ]{1,2})[\s-]?(\d{1,4})$/);
  if (!match) return null;
  return { district: match[1], letters: match[2], number: match[3] };
}

/**
 * Hauptfunktion: validiert ein deutsches Kfz-Kennzeichen.
 *
 * @param {string} raw - Roh-Eingabe (z.B. "M-AB 1234", "m ab 1234", "MAB1234")
 * @returns {{
 *   valid: boolean,
 *   normalized: string,
 *   district: string | null,
 *   city: string | null,
 *   state: string | null,
 *   letters: string | null,
 *   number: string | null,
 *   reason: string | null,
 * }}
 */
export function validatePlate(raw) {
  const input = (raw || "").trim();
  if (!input || input.length < 3) {
    return {
      valid: false, normalized: input, district: null, city: null,
      state: null, letters: null, number: null, reason: null,
    };
  }

  const district = extractDistrictCode(input);
  if (!district) {
    return {
      valid: false, normalized: input, district: null, city: null,
      state: null, letters: null, number: null,
      reason: 'Format nicht erkannt — bitte als „M-AB 1234" eingeben',
    };
  }

  const registry = PLATE_REGISTRY[district] || null;
  const parsed = parsePlateBody(input);

  // City known but body not yet complete = "almost there"
  if (registry && !parsed) {
    return {
      valid: false,
      normalized: input,
      district,
      city: registry.city,
      state: registry.state,
      letters: null,
      number: null,
      reason: "Buchstaben + Nummer fehlen noch",
    };
  }

  if (!registry) {
    return {
      valid: false,
      normalized: input,
      district,
      city: null,
      state: null,
      letters: parsed?.letters || null,
      number: parsed?.number || null,
      reason: `Unterscheidungszeichen „${district}" ist nicht im Verzeichnis (kann ein valides Wunschkennzeichen sein)`,
    };
  }

  return {
    valid: true,
    normalized: `${parsed.district}-${parsed.letters} ${parsed.number}`,
    district: parsed.district,
    city: registry.city,
    state: registry.state,
    letters: parsed.letters,
    number: parsed.number,
    reason: null,
  };
}
